var axios = require('axios')
var api_url = process.env.prefix_report + '/audit-log';

axios.listAllAuditRecords = function (params, success, callBackError) {
  this.get(api_url + '/list?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getDetailedLogInsight = function (uuid, success, callBackError) {
  this.get(api_url + '/detail/' + uuid)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios


// WEBPACK FOOTER //
// ./src/assets/api/Audit.js